const navigation = [
  { name: 'About', href: '#about' },
  { name: 'Experience', href: '#experience' },
  { name: 'Projects', href: '#projects' },
  { name: 'Skills', href: '#skills' },
  { name: 'Contact', href: '#contact' },
];

export default function Footer() {
  return (
    <footer className="app-footer govuk-footer">
      <div className="govuk-width-container">
        <div className="govuk-footer__meta">
          <div className="govuk-footer__meta-item govuk-footer__meta-item--grow">
            <h2 className="govuk-visually-hidden">Site links</h2>
            <ul className="govuk-footer__inline-list">
              {navigation.map((item) => (
                <li className="govuk-footer__inline-list-item" key={item.name}>
                  <a className="govuk-footer__link" href={item.href}>{item.name}</a>
                </li>
              ))}
              <li className="govuk-footer__inline-list-item">
                <a className="govuk-footer__link" href="https://www.linkedin.com/in/harshbtrivedi/" target="_blank" rel="noopener noreferrer">
                  LinkedIn
                </a>
              </li>
              <li className="govuk-footer__inline-list-item">
                <a className="govuk-footer__link" href="https://github.com/harrytrivedi" target="_blank" rel="noopener noreferrer">
                  GitHub
                </a>
              </li>
            </ul>
            <p className="govuk-body-s">
              &copy; {new Date().getFullYear()} Harsh Trivedi. All rights reserved.
            </p>
            <p className="govuk-body-s">
              This is my personal portfolio, built using the{' '}
              <a className="govuk-footer__link" href="https://design-system.service.gov.uk/" target="_blank" rel="noopener noreferrer">
                GOV.UK Design System
              </a>
              . It is not an official government service.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
